import CCActionTypes from '../action-types/cc-mode';
const INITIAL_STATE = {
    ccMode: undefined,
    notifications: [],
    showBubbleAboveCCMode: false,
};
const ccModeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CCActionTypes.ADD_NOTIFICATION:
            return Object.assign(Object.assign({}, state), { notifications: [...state.notifications, action.payload] });
        case CCActionTypes.CLEAR_NOTIFICATIONS:
            return Object.assign(Object.assign({}, state), { notifications: [] });
        case CCActionTypes.DELETE_NOTIFICATION:
            return Object.assign(Object.assign({}, state), { notifications: [
                    ...state.notifications.slice(0, action.payload),
                    ...state.notifications.slice(action.payload + 1),
                ] });
        case CCActionTypes.SET_MODE:
            return Object.assign(Object.assign({}, state), { ccMode: action.payload });
        case CCActionTypes.SET_SHOW_BUBBLE_ABOVE_CC_MODE:
            return Object.assign(Object.assign({}, state), { showBubbleAboveCCMode: action.payload });
        default:
            return state;
    }
};
export default ccModeReducer;
